import {BufferAttribute, BufferGeometry} from "three";

let geom;

export function useTimpanumGeometry()
{
    if (!geom) {
        geom = new BufferGeometry();
        const vertices = new Float32Array([ 0, 1, 0, 0.5, 0, 0, -0.5, 0, 0 ]);
        const normals = new Float32Array([ 0, 0, 1, 0, 0, 1, 0, 0, 1 ]);
        const uvs = new Float32Array([ 0.5, 0, 1, 1, 0, 1 ]);
        const indices = [ 0, 2, 1 ];
        geom.setAttribute("position", new BufferAttribute(vertices, 3));
        geom.setAttribute("normal", new BufferAttribute(normals, 3, true));
        geom.setAttribute("uv", new BufferAttribute(uvs, 2));
        geom.setIndex(indices);
    }
    return geom;
}